import React from "react";
import { NavbarComp } from '../../component/navbar/navbar';
import { ContentComp } from '../../component/content/content';
import { Services } from '../../component/services/services';
import { CarLists } from '../../component/car-lists/carslists';
import { Testimoni } from '../../component/testimoni/testimoni';
import { Footer } from '../../component/footer/footer';
import { Location } from '../../component/location/location'

export function Home() {
    return(
        <div> 
            <NavbarComp size = '50'/>
            <ContentComp />
            <CarLists />
            <Testimoni />
            <Services />
            <Location />
            <Footer size='30' />
        </div>
    )
}


 

